module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/client-new/client-new.component.css
// module id = ./src/app/admin/client-new/client-new.component.css
// module chunks = main